/**
 * La Europea — Mobile Menu Slide Navigation
 * Converts accordion drawer menu into level-based slide navigation.
 * Only runs on mobile (<750px). Desktop is untouched.
 */
(function() {
  if (window.innerWidth >= 750) return;

  var BACK_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18l-6-6 6-6" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // Wait for drawer to exist in DOM
  function init() {
    var menuList = document.querySelector('.menu-drawer__menu.has-submenu');
    var nav = document.querySelector('.menu-drawer__navigation');
    if (!menuList || !nav) {
      setTimeout(init, 300);
      return;
    }

    // Hide "Rewards" from mobile menu
    var allItemsRaw = menuList.querySelectorAll(':scope > li');
    allItemsRaw.forEach(function(li) {
      var text = li.querySelector('.menu-drawer__menu-item-text');
      if (text && text.textContent.trim().toLowerCase() === 'rewards') {
        li.style.display = 'none';
      }
    });

    // Handle ALL menu items — intercept clicks for items that have children
    var allItems = menuList.querySelectorAll(':scope > li');
    allItems.forEach(function(li) {
      var childList = li.querySelector('.menu-drawer__menu--childlist');
      var details = li.querySelector('details');

      if (!childList && !details) return; // No children, let it navigate normally

      var clickTarget = details ? details.querySelector('summary') : li.querySelector('.menu-drawer__menu-item--mainlist');
      if (!clickTarget) return;

      clickTarget.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openLevel2(li, nav, menuList);
      });
    });
  }

  function openLevel2(li, nav, menuList) {
    // Get data
    var details = li.querySelector('details');
    var title = li.querySelector('.menu-drawer__menu-item-text')?.textContent?.trim() || '';
    var childLinks = li.querySelectorAll('.menu-drawer__menu--childlist > li');
    var gridImages = li.querySelectorAll('.menu-drawer__link-image');

    // Remove existing level 2 panel
    var existing = nav.querySelector('.le-menu-level2');
    if (existing) existing.remove();

    // Build level 2 panel
    var panel = document.createElement('div');
    panel.className = 'le-menu-level2';

    // Back button
    var backBtn = document.createElement('button');
    backBtn.className = 'le-menu-back';
    backBtn.type = 'button';
    backBtn.innerHTML = BACK_SVG;
    backBtn.addEventListener('click', function() {
      closeLevel2(panel, menuList);
    });
    panel.appendChild(backBtn);

    // Child links
    var linksList = document.createElement('ul');
    linksList.className = 'le-menu-level2__links';

    childLinks.forEach(function(childLi) {
      var a = childLi.querySelector('a');
      if (!a) return;
      var newLi = document.createElement('li');
      var newA = document.createElement('a');
      newA.className = 'le-menu-level2__link';
      newA.href = a.href;
      newA.textContent = a.querySelector('.menu-drawer__menu-item-text')?.textContent?.trim() || a.textContent.trim();

      // Add chevron if it has further children (though unlikely at level 3)
      newA.innerHTML += '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6l6 6-6 6" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      newLi.appendChild(newA);
      linksList.appendChild(newLi);
    });
    panel.appendChild(linksList);

    // Promo cards — look for images in the mega menu data
    // Check if there are collection images rendered in the drawer
    var promoImages = li.querySelectorAll('.menu-drawer__link-image, .mega-menu__media img, .link-featured-image');
    if (promoImages.length > 0) {
      var promosDiv = document.createElement('div');
      promosDiv.className = 'le-menu-level2__promos';

      // Take first 2 promo images
      var count = 0;
      promoImages.forEach(function(img) {
        if (count >= 2) return;
        var parentA = img.closest('a');
        var promoLink = document.createElement('a');
        promoLink.className = 'le-menu-level2__promo';
        promoLink.href = parentA ? parentA.href : '#';

        var promoImg = document.createElement('img');
        promoImg.className = 'le-menu-level2__promo-img';
        promoImg.src = img.src || img.querySelector('img')?.src || '';
        promoImg.alt = '';
        promoImg.loading = 'lazy';

        var promoName = document.createElement('span');
        promoName.className = 'le-menu-level2__promo-name';
        promoName.textContent = parentA?.querySelector('.menu-drawer__menu-item-text')?.textContent?.trim() || '';

        var promoDiscover = document.createElement('span');
        promoDiscover.className = 'le-menu-level2__promo-link';
        promoDiscover.textContent = 'Descubrir';

        promoLink.appendChild(promoImg);
        promoLink.appendChild(promoName);
        promoLink.appendChild(promoDiscover);
        promosDiv.appendChild(promoLink);
        count++;
      });

      if (count > 0) panel.appendChild(promosDiv);
    }

    // Try to find promo cards from the desktop mega-menu for this category
    var parentText = title.toLowerCase().trim();
    var allMegaMenus = document.querySelectorAll('.mega-menu');
    allMegaMenus.forEach(function(mm) {
      var menuLink = mm.closest('li')?.querySelector('.mega-menu__link, .header-menu__link');
      var menuText = menuLink?.textContent?.trim()?.toLowerCase() || '';
      if (menuText.includes(parentText) || parentText.includes(menuText)) {
        var promoCards = mm.querySelector('.le-mega-promo-cards');
        if (promoCards) {
          var cloned = promoCards.cloneNode(true);
          cloned.style.display = 'flex';
          cloned.style.gap = '16px';
          cloned.style.marginTop = '24px';
          panel.appendChild(cloned);
        }
      }
    });

    // Add panel to nav
    nav.appendChild(panel);

    // Add class to drawer to hide X button
    var drawer = nav.closest('.menu-drawer') || nav.closest('[data-header-drawer]');
    if (drawer) drawer.classList.add('le-menu-l2-open');

    // Animate
    requestAnimationFrame(function() {
      menuList.classList.add('le-menu-l1--hidden');
      panel.classList.add('le-menu-level2--active');
    });
  }

  function closeLevel2(panel, menuList) {
    menuList.classList.remove('le-menu-l1--hidden');
    panel.classList.remove('le-menu-level2--active');

    // Restore X button
    var drawer = menuList.closest('.menu-drawer') || menuList.closest('[data-header-drawer]');
    if (drawer) drawer.classList.remove('le-menu-l2-open');

    setTimeout(function() {
      panel.remove();
    }, 350);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when drawer opens (in case of SPA-like navigation)
  document.addEventListener('click', function(e) {
    if (e.target.closest('.header__icon--menu')) {
      setTimeout(init, 100);
    }
  });
})();
